<template>
    <div>
        <div class="d-flex flex-wrap explain">
            <b-badge variant="success" class="mr-1" pill></b-badge> {{ 'guessed_symbols' | lang }}
            <b-badge variant="dark" pill class="ml-2 mr-1"></b-badge> {{ 'ticket_price' | lang }}
        </div>
        <b-table-simple responsive>
            <b-thead head-variant="dark">
                <b-tr>
                    <b-th class="hidden-row"></b-th>
                    <b-th v-for="{ amount } in amounts" :key="amount">{{ amount | currency }}</b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr v-for="(guessed, index) in guessNumbers" :key="guessed">
                    <b-td :variant="index % 2 ? 'success-light' : 'success'">{{ guessed }}</b-td>
                    <b-td :variant="index % 2 ? 'light' : ''" v-for="({ amount, pool }, poolIndex) in amountsByGuessed(guessed)" :key="poolIndex">
                        <template v-if="pool">
                            {{ pool.name }} <span class="text-danger">**</span>
                        </template>
                        <template v-else-if="amount > 0">{{ amount | currency }}</template>
                        <template v-else>-</template>
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>
        <div>
            <span class="text-danger">**</span>
            <span>{{ 'rules.if_more_winners' | lang }}</span>
            <div>(*) {{ 'rules.combinator' | lang }}</div>
        </div>
    </div>
</template>

<script>
import { head } from 'lodash';
import lang from '@tv/filters/lang';
import currency from '@tv/filters/currency';

export default {
    props: ['game'],

    computed: {
        amounts() {
            return Object.values(this.game.amounts);
        },

        guessNumbers() {
            const values = Object.values(this.game.guesses_values)
                .map(item => item.guessed);
            
            return [ ...new Set(values) ].sort().reverse();
        },
    },

    methods: {
        amountsByGuessed(guessNumber) {
            const amounts = [];

            const firstAmount = head(this.amounts).amount;

            for (const { amount } of this.amounts) {
                for (const guessValue of Object.values(this.game.guesses_values)) {
                    if ( guessValue.guessed ==  guessNumber) {
                        const pool = Object.values(this.game.pools)
                            .find(pool => pool.guessed == guessValue.guessed);

                        if ( pool || amount != firstAmount ) {
                            amounts.push({ pool, amount: amount * guessValue.multiplier });
                        } else {
                            amounts.push({ amount: 0 });
                        }
                        
                        break;
                    }
                }
            }

            return amounts;
        },
    },
}
</script>